import { useContext, useEffect } from 'react'
import { useRootStore } from '@/contexts/root-store-context'
import { DocumentTitleContext } from '@/components/DocumentTitleProvider'

/**
 * Sets the document title.
 */
export function useDocumentTitle(title: string | null | undefined) {
  const {
    shell: {
      shellInfo: { name: workspaceName },
    },
  } = useRootStore()

  const { set, currentTitleRef } = useContext(DocumentTitleContext)

  useEffect(() => {
    if (!title) {
      return
    }

    const previousTitle = currentTitleRef.current
    set(
      workspaceName
        ? title
          ? `${title} - ${workspaceName}`
          : workspaceName
        : previousTitle,
    )
    return () => {
      set(previousTitle)
    }
  }, [title, workspaceName, set, currentTitleRef])
}
